import WebRequest from "./WebRequest";
import Configuration from "../foundation/Configuration";

class DatastoreRendering extends WebRequest {
    protected static get includeAuth(): boolean {
        return true;
    }
    
    static override get basePath(): string {
        return `${Configuration.renderingPath}/`;
    }
}

export default DatastoreRendering;
